import { createActivityLog } from "../api/activity";
import { AUTH_USER_KEY } from "./authSession";

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem(AUTH_USER_KEY) || "{}");
  } catch {
    return {};
  }
};

export const logEmployeeActivity = async (payload = {}) => {
  const user = getStoredUser();
  const actorId = payload.actorId ?? user.id ?? null;
  const actorName = payload.actorName ?? user.name ?? "Unknown User";
  const targetEmployeeId =
    payload.targetEmployeeId ?? payload.employeeId ?? actorId ?? null;
  const targetEmployeeName =
    payload.targetEmployeeName ??
    payload.employeeName ??
    actorName;

  try {
    await createActivityLog({
      actorId,
      actorName,
      targetEmployeeId,
      targetEmployeeName,
      employeeId: targetEmployeeId,
      employeeName: targetEmployeeName,
      action: payload.action,
      module: payload.module,
      description: payload.description,
      timestamp: payload.timestamp ?? new Date().toISOString(),
    });

    return true;
  } catch (error) {
    console.warn("Employee activity log skipped:", error?.message || error);
    return false;
  }
};
